module.exports = __webpack_public_path__ + "static/media/loading8new.055b0719.gif";